
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2,0,0,2,0,0)"}},[_c('defs',[_c('style',[_v('.a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}')])]),_c('title',[_v('app-window-error-404')]),_c('rect',{staticClass:"a",attrs:{"x":"1.51","y":"2.253","width":"21","height":"19.5","rx":"1.5","ry":"1.5"}}),_c('line',{staticClass:"a",attrs:{"x1":"1.51","y1":"6.753","x2":"22.51","y2":"6.753"}}),_c('path',{staticClass:"a",attrs:{"d":"M7.51,15.753h-3v-1.5a3,3,0,0,1,3-3v6"}}),_c('path',{staticClass:"a",attrs:{"d":"M19.51,15.753h-3v-1.5a3,3,0,0,1,3-3v6"}}),_c('path',{staticClass:"a",attrs:{"d":"M13.51,15.753a1.5,1.5,0,0,1-3,0v-3a1.5,1.5,0,0,1,3,0Z"}})])])
          )
        }
      }
    